<control-dropdown [control]="control" [config]="statesConfig">
</control-dropdown>
